const $ = jQuery.noConflict();
import FormLabel from './formLabel';

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBody: $('body'),

	$domHiddenSpanPhone: $('.js-form-hidden-text-phone'),
	$domHiddenSpanMail: $('.js-form-hidden-text-mail'),
	$domHiddenSpanFax: $('.js-form-hidden-text-fax'),
	$domPhoneField: $('.phone-mail'),
	$domMailField: $('.mail-mail'),
	$domFaxField: $('.fax-mail'),

	/** @description Initialize */
	init: function() {
		this.afterFormSubmit();

		const phoneTxt = this.$domHiddenSpanPhone.text();
		this.$domPhoneField.find('input').val(phoneTxt);

		const mailTxt = this.$domHiddenSpanMail.text();
		this.$domMailField.find('input').val(mailTxt);

		const faxTxt = this.$domHiddenSpanFax.text();
		this.$domFaxField.find('input').val(faxTxt);
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	// afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 4000) => {
	// 	document.addEventListener('wpcf7mailsent', (e) => {
	// 		const formId = e.detail.id;
	// 		console.log(formId);
	// 		console.log($(`#${formId}`).parents(formHolder));

	// 		FormHelpers.$domBody.removeClass('prevent-scroll');
	// 		$(`#${formId}`).parents(formHolder).addClass(sentClass);
	// 		$('.' + FormLabel.classMoved).removeClass(FormLabel.classMoved);
	// 		$('.wpcf7-form .select2-selection__rendered').empty();
	// 		$('.wpcf7-form').find('.js-custom-file').text('');
	// 		$('.contact-career__wrapper-input--file').find('label').css("opacity", "1");

	// 		setTimeout(() => {
	// 			$(formHolder).removeClass(sentClass);
	// 		}, delay);
	// 	}, false);
	// }

	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 4000) => {
    document.addEventListener('wpcf7mailsent', (e) => {
        // Try multiple properties to get the form ID
        const formId = e.detail.contactFormId || e.detail.id || e.target.getAttribute('data-wpcf7-id');
        
        // Get the form element - e.target is the actual form element
        const $form = $(e.target);
        const $formParent = $form.closest(formHolder);
        FormHelpers.$domBody.removeClass('prevent-scroll');
        $formParent.addClass(sentClass);
        
        $('.' + FormLabel.classMoved).removeClass(FormLabel.classMoved);
        $('.wpcf7-form .select2-selection__rendered').empty();
        $('.wpcf7-form .js-custom-file').text('');
        $('.contact-career__wrapper-input--file label').css("opacity", "1");

        setTimeout(() => {
            $(formHolder).removeClass(sentClass);
        }, delay);
    }, false);
}
};

export default FormHelpers;
